import React from 'react'
import Typography from '@mui/material/Typography'
import tony from '../../assets/images/Anthony.jpeg'
import '../Profile/Profile.css'
import TimelineComponent from './../Timeline/TimelineComponent'
import ProfileData from '../../utils/ProfileData'
import PersonPinIcon from '@mui/icons-material/PersonPin'
import { TimelineContent, TimelineItem } from '@mui/lab'
import CustomTimelineSeperator from './../Timeline/CustomTimelineSeperator'
import CustomTimelineLast from './../Timeline/CustomeTimelineLast'
import CustomButton from './../Button/CustomButton'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

const CustomTimelineItem = ({ title, text }) => {
  return (
    <TimelineItem className='timeline-line'>
      <CustomTimelineSeperator />
      <TimelineContent>
        <Typography className='profile-data'>
          {title}:<span className='grey-font'>{text}</span>
        </Typography>
      </TimelineContent>
    </TimelineItem>
  )
}
export const CustomTimelineItemLast = ({ title, text }) => {
  return (
    <TimelineItem>
      <CustomTimelineLast />
      <TimelineContent>
        <Typography className='profile-data'>
          {`${title}:`}
          <span className='grey-font'>{text}</span>
        </Typography>
      </TimelineContent>
    </TimelineItem>
  )
}
const Profile = () => {
  return (
    <div className='profile br1'>
      <div className='profile-details'>
        <Typography variant='h6' color='initial' className='profile-name'>
          {ProfileData.name}
        </Typography>
        <Typography className='profile-title' color='#777777'>
          {ProfileData.title}
        </Typography>
      </div>
      <div className='profile-image'>
        <img src={tony} alt='profile pix' />
      </div>
      <div className='profile-information'>
        <TimelineComponent icon={<PersonPinIcon />}>
          <CustomTimelineItem title='Title' text={ProfileData.jobDescription} />
          <CustomTimelineItem title='Birthday' text={ProfileData.birthday} />
          <CustomTimelineItem title='Job' text={ProfileData.job} />
          <CustomTimelineItem title='email' text={ProfileData.email} />
          <CustomTimelineItemLast title='phone' text={ProfileData.phone} />
        </TimelineComponent>
        <a href='TonyCv.pdf' download='Anthony TonyCv.pdf' style={{textDecoration: 'none'}} target='_blank'>
          <CustomButton text='Download Cv' icon={<FileDownloadIcon />} />
        </a>
      </div>
    </div>
  )
}

export default Profile
